/* ============================================================================
   v4-bundle-selector.js
   Drives the probiotics bundle selector in the V4 buy box.

   Two modes (set via data-mode on .v4-bundle):
     - "variants"  : each card's data-value is a VARIANT OPTION VALUE. Selecting
                     a card sets the native (hidden) <select data-variant-input>
                     and fires `change`, so v4-product.js updates price, master
                     select, and gallery natively. If no such select exists, we
                     fall back to setting [data-product-select] by variant id.
     - "quantity"  : each card's data-value is a QUANTITY. Selecting a card sets
                     a hidden <input name="quantity"> bound to the product form.

   Scoped, defensive, no dependencies. Loaded only when the bundle is enabled.
   ============================================================================ */
(function () {
  'use strict';

  function initBundle(root) {
    if (root.__bundleInit) return;
    root.__bundleInit = true;

    var mode = root.getAttribute('data-mode') || 'variants';
    var formId = root.getAttribute('data-form-id') || '';
    var section = root.closest('.v4-pdp') || document;
    var radios = Array.prototype.slice.call(root.querySelectorAll('.v4-bundle__radio'));
    if (!radios.length) return;

    function ensureQtyInput() {
      var input = formId
        ? document.querySelector('input[name="quantity"][form="' + formId + '"]')
        : null;
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'quantity';
        input.value = '1';
        if (formId) input.setAttribute('form', formId);
        root.appendChild(input);
      }
      return input;
    }

    function applyVariant(value) {
      if (!value) return false;
      // Variants mode drives the native v4 variant <select>(s). The V4 submit
      // handler (v4-product.js) RE-RESOLVES the variant from these selects at
      // submit time via getSelectedOptionsFromUI(), then overwrites the master
      // [name="id"]. So driving the native select is the ONLY reliable path —
      // setting [data-product-select] directly would be discarded at submit.
      //
      // We only change a select that ACTUALLY has a matching option, so a card
      // whose value isn't (yet) mapped to a real variant can never corrupt the
      // chosen variant — the form stays on its valid default and add-to-cart +
      // the cart drawer keep working.
      var selects = section.querySelectorAll('select[data-variant-input]');
      for (var s = 0; s < selects.length; s++) {
        var sel = selects[s];
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].value === value) {
            if (sel.selectedIndex !== i) {
              sel.selectedIndex = i;
              sel.dispatchEvent(new Event('change', { bubbles: true }));
            }
            return true;
          }
        }
      }
      return false;
    }

    function onSelect(radio) {
      var wraps = root.querySelectorAll('.v4-bundle__cardwrap');
      for (var i = 0; i < wraps.length; i++) wraps[i].classList.remove('is-selected');

      var wrap = radio.closest('.v4-bundle__cardwrap');
      if (wrap) wrap.classList.add('is-selected');

      // keep aria-checked in sync on the label
      var labels = root.querySelectorAll('.v4-bundle__card');
      for (var j = 0; j < labels.length; j++) labels[j].setAttribute('aria-checked', 'false');
      var label = wrap && wrap.querySelector('.v4-bundle__card');
      if (label) label.setAttribute('aria-checked', 'true');

      var value = radio.value;
      if (mode === 'quantity') {
        ensureQtyInput().value = value || '1';
      } else {
        applyVariant(value);
      }
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (r.checked) onSelect(r);
      });
    });

    // Initialise from the pre-checked card (or the first one).
    var checked = root.querySelector('.v4-bundle__radio:checked') || radios[0];
    if (checked) {
      checked.checked = true;
      onSelect(checked);
    }
  }

  function initAll() {
    var nodes = document.querySelectorAll('.v4-bundle');
    for (var i = 0; i < nodes.length; i++) initBundle(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
